var map = {
	"./components/ApiWidget.vue": 4858,
	"./components/ButtonSelectorWidget.vue": 9819,
	"./components/ButtonWidget.vue": 2224,
	"./components/Captcha.vue": 9769,
	"./components/ChartLegend.vue": 2798,
	"./components/ChartWidget.vue": 8884,
	"./components/CompanySelectorWidget.vue": 5199,
	"./components/ContactDetailsWidget.vue": 9762,
	"./components/DataTable.vue": 4183,
	"./components/DataTableBody.vue": 8404,
	"./components/DataTableFooter.vue": 9892,
	"./components/DataTableHeader.vue": 8340,
	"./components/DatePicker.vue": 9318,
	"./components/Flash.vue": 8094,
	"./components/FooterWidget.vue": 8395,
	"./components/ImageSliderComponent.vue": 5387,
	"./components/InvestorSelectorWidget.vue": 1777,
	"./components/InvisibleSelectorWidget.vue": 5108,
	"./components/Loading.vue": 3737,
	"./components/NumberSelectorWidget.vue": 2621,
	"./components/ProgressBar.vue": 7917,
	"./components/ResearchCreatorWidget.vue": 2073,
	"./components/RiskProfilerWidget.vue": 4032,
	"./components/RiskRatedReportWidget.vue": 258,
	"./components/ScaleSelectorWidget.vue": 8870,
	"./components/SchemeSelectorWidget.vue": 1526,
	"./components/SearchStringSelectorWidget.vue": 3101,
	"./components/SelectSelectorWidget.vue": 5632,
	"./components/SelectorWidget.vue": 6951,
	"./components/TableWidget.vue": 8281,
	"./components/TextExtended.vue": 8798,
	"./components/TextWidget.vue": 1798,
	"./components/ToggleSelectorWidget.vue": 7536,
	"./components/UserSelectorWidget.vue": 699,
	"./components/VisibleSelectorWidget.vue": 9475,
	"./components/Widget.vue": 7028,
	"./components/WidgetDescription.vue": 3223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7373;